import NextImage from 'next/image';
import React from 'react';

type CardContent = {
  icon: string;
  heading: string;
  description: string;
};

type identifiers = {
  id: string;
  className?: string;
};

interface RequirementCardProps {
  identifiers: identifiers;
  cardContent: CardContent;
  isSelected: boolean;
  onChange: () => void;
}

const RequirementCardCmp: React.FC<RequirementCardProps> = ({
  identifiers: { id, className = '' },
  cardContent: { icon, heading, description },
  isSelected,
  onChange,
}) => {
  return (
    <div
      id={id}
      className={`flex items-center justify-between p-4 rounded-md transition-all duration-300 ${
        isSelected ? '' : 'border-gray-300'
      } ${className}`}
      style={{
        outline: isSelected
          ? '.2rem solid rgba(10, 87, 255, .839)'
          : '.1rem solid rgba(78, 82, 91, .12)',
        outlineOffset: '2px',
      }}
      onClick={onChange}
    >
      <div className="flex items-center">
        <NextImage
          src={icon}
          alt="icon"
          width={46}
          height={46}
          className="mr-4 object-contain"
        />
      </div>
      <div id={`${id}-title`} className="flex-1">
        <div className="font-semibold text-[1.4rem] leading-normal normal-case">
          {heading}
        </div>
        <div
          id={`${id}-desc`}
          className="text-[#5f636d] text-[1.2rem] font-normal leading-[1.6rem] max-w-[25rem] capitalize"
        >
          {description}
        </div>
      </div>
      <div className="flex items-center">
        <input
          type="radio"
          checked={isSelected}
          onChange={onChange}
          className="form-radio h-8 w-8 text-blue-500"
        />
      </div>
    </div>
  );
};

export default RequirementCardCmp;
